import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import App from "./App";
import { fetchCrossword } from "./reducers/crossword/actions";
import { fetchLevels } from "./reducers/levels/actions";
import { getLoading } from "./reducers/crossword/selectors";
import { initUri } from "./reducers/crossword/uriActions";
import { fetchUserSession } from "./reducers/user/actions";
import { getShowPrizes } from "./reducers/ui/selectors";

const mapStateToProps = state => ({
  loading: getLoading(state),
  prizesShowing: getShowPrizes(state)
});

const mapDispatchToProps = dispatch => ({
  fetchUserSession: () => dispatch(fetchUserSession()),
  fetchCrossword: (lang, seed, level, secret) =>
    dispatch(fetchCrossword(lang, seed, level, secret)),
  fetchLevels: lang => dispatch(fetchLevels(lang)),
  initUri: () => dispatch(initUri())
});
@withRouter
@connect(
  mapStateToProps,
  mapDispatchToProps
)
export default class AppContainer extends Component {
  componentDidMount = () => {
    this.loadUserSession().then(() => {
      this.loadLevels();
      this.loadCrossword();
    });
  };

  componentDidUpdate = prevProps => {
    if (this.props.match.params !== prevProps.match.params) {
      this.loadCrossword();
      this.loadLevels();
    }
  };

  loadUserSession = () => this.props.fetchUserSession();

  loadCrossword = () => {
    const { match } = this.props;
    const { lang, seed, level, secret = "" } = match.params;

    if (lang && seed && level) {
      this.props.fetchCrossword(lang, seed, level, atob(secret));
    } else {
      this.props.initUri();
    }
  };

  loadLevels = () => this.props.fetchLevels(this.props.match.params.lang);

  render = () => <App {...this.props} />;
}



// WEBPACK FOOTER //
// ./src/AppContainer.js